'use strict';

var constants = require('../constants.cjs');
var apiError = require('./apiError.cjs');
var axiosError = require('./axiosError.cjs');

const EMPTY_STATUS = 0;
function getIgnoreReactQueryErrorHandler(excludeErrorStatus) {
  const excludeErrorStatuses = Array.isArray(excludeErrorStatus) ? excludeErrorStatus : [excludeErrorStatus];
  const retry = (failureCount, error) => {
    if (axiosError.isAxiosError(error) && excludeErrorStatuses.includes(error.response?.status ?? EMPTY_STATUS)) {
      return false;
    }
    if (failureCount > 3) {
      return false;
    }
    const [errorType] = apiError.decideError(error);
    return errorType !== constants.HttpErrorType.Unauthorized && errorType !== constants.HttpErrorType.Forbidden;
  };
  const isUseErrorBoundary = (error) => axiosError.isAxiosError(error) && !excludeErrorStatuses.includes(error.response?.status ?? EMPTY_STATUS);
  return { retry, isUseErrorBoundary };
}

exports.getIgnoreReactQueryErrorHandler = getIgnoreReactQueryErrorHandler;
//# sourceMappingURL=reactQuery.cjs.map
